import React from 'react';

import { Category } from 'api/cms';
import { Box } from 'components/Box';
import { Tag } from 'components/Tag';

type Props = {
  homePageUrl: string;
  categories: Array<Category>;
};

export function ContentPageCategories({ homePageUrl, categories }: Props) {
  return (
    <Box data-qa-id="categories" display="flex" m="-6px" flexWrap="wrap">
      {categories.map((category) => (
        <Tag
          key={category.slug}
          component={homePageUrl && 'a'}
          disabled={!homePageUrl && 'disabled'}
          data-qa-id="category-link"
          href={
            homePageUrl ? `/${homePageUrl}?categories=${category.slug}&pq=` : ''
          }
          m="6px"
          large
        >
          {category.name}
        </Tag>
      ))}
    </Box>
  );
}
